module.exports = __webpack_public_path__ + "img/apart08.95d24b3a.png";